import { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import useAuth from '@hooks/use-auth';
import { Loader2 } from 'lucide-react';
import { useLanguage } from '@contexts/LanguageContext';

export default function AuthLayout() {
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Add a small delay to prevent blinking during auth check
    const timer = setTimeout(() => {
      setLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Helper function to get user email from localStorage
  const getUserEmail = () => {
    if (typeof window !== 'undefined') {
      const authData = localStorage.getItem('authData');
      if (authData) {
        try {
          const parsed = JSON.parse(authData);
          return parsed.email?.toLowerCase() || '';
        } catch {
          return '';
        }
      }
    }
    return '';
  };

  if (loading) {
    return (
      <div role="status" className="flex h-screen items-center justify-center">
        <Loader2 aria-hidden className="size-8 animate-spin motion-reduce:animate-none text-fg-muted" />
        <span className="sr-only">{t('lumen.frame.loadingPage')}</span>
      </div>
    );
  }

  if (isAuthenticated) {
    const userEmail = getUserEmail();
    // Redirect Samuel to dashboard, others to doc-pabean
    if (userEmail.includes('samuel')) {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/doc-pabean" replace />;
  }

  return <Outlet />;
}
